<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="addSeedbedsForm"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}:
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import StepConfirm from './steps/StepConfirm.vue';
import ThirdStep from './steps/ThirdStep.vue';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    StepConfirm,
    ThirdStep,
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      model: {
        id: null,
        name: null,
        tradename: null,
        nit: null,
        address: null,
        city: null,
        state: null,
        country: null,
        email: null,
        phone: null,
        icon: null,
        web_site: null,
        comercial_activity: null,
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
      },
    };
  },
  mixins: [MixinLoading, MixinMenu, MixinPermissions, MixinAlert],
  computed: {
    tabsContent() {
      return [
        {
          title: i18n.t('common_words.general_information'),
          reference: 'firstStep',
          component: FirstStep,
        },
        {
          title: i18n.t('common_words.location'),
          reference: 'secondStep',
          component: SecondStep,
        },
        {
          title: i18n.t('common_words.contact'),
          reference: 'thirdStep',
          component: ThirdStep,
        },
      ];
    },
  },
  methods: {
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].model = {
        id: null,
        nit: null,
        name: null,
        phone: null,
        email: null,
        tradename: null,
        web_site: null,
        icon: null,
        comercial_activity: null,
      };
      this.$refs.formWizard.$refs.secondStep[0].model = {
        address: null,
        country: null,
        city: null,
        state: null,
      };
      this.$refs.formWizard.$refs.thirdStep[0].model = {
        nContacts: 0,
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
      };
      this.model = {
        id: null,
        name: null,
        tradename: null,
        nit: null,
        address: null,
        city: null,
        state: null,
        country: null,
        email: null,
        phone: null,
        icon: null,
        web_site: null,
        comercial_activity: null,
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
      };
    },

    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
    },

    addSeedbedsForm() {
      this.showHideLoading(true);
      this.model.route = 'seeding/seedbeds';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/seedbeds',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/seedbeds',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('seeding/seedbeds');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('seeding/seedbeds');
  },
};
</script>
